import script from "./SelectMenuCustomWithAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectMenuCustomWithAvatar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__